module.exports = __webpack_public_path__ + "img/7.ed2f2da4.png";